import React from 'react';

import { Heading, Projects } from '../../../components';



const ProjectSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Projects'} subTitle={'Solar Success Stories'} />

      {/* Project Section */}
      <Projects />

    </section>

  );
}

export default ProjectSection;